import React, { useState } from 'react'
import { Container, Typography, Stack, Paper, useTheme, TextField, Button, Grid, Card, CardContent } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'

export const ContactPage = () => {
  const theme = useTheme()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // In a real app, send this to backend
    console.log('Form submitted:', formData)
    alert('Thank you for your message! We\'ll get back to you soon.')
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    })
  }

  return (
    <Stack minHeight="100vh" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ flex: 1, py: 4 }}>
        <Typography variant="h3" sx={{ mb: 1, fontWeight: 'bold', color: theme.palette.primary.main, textAlign: 'center' }}>
          Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', textAlign: 'center' }}>
          Have questions? We'd love to hear from you. Get in touch with our team today!
        </Typography>

        <Grid container spacing={3}>
          {/* Contact Info Cards */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', boxShadow: 2 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <EmailIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Email
                </Typography>
                <Typography variant="body2">
                  sardarlaeiq786@gmail.com
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', boxShadow: 2 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <WhatsAppIcon sx={{ fontSize: 40, color: '#25D366', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  WhatsApp
                </Typography>
                <Typography variant="body2">
                  +923448252109
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', boxShadow: 2 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <PhoneIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Phone
                </Typography>
                <Typography variant="body2">
                  03448252109
                </Typography>
              </CardContent>
            </Card>
          </Grid>


          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', boxShadow: 2 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <LocationOnIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Location
                </Typography>
                <Typography variant="body2">
                  Pakistan
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Contact Form */}
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ p: 4, backgroundColor: theme.palette.background.paper }}>
              <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
                Send us a Message
              </Typography>
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Your Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    variant="outlined"
                  />

                  <TextField
                    fullWidth
                    label="Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />

                  <TextField
                    fullWidth
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    multiline
                    rows={5}
                    variant="outlined"
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: 'white',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark
                      }
                    }}
                  >
                    Send Message
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Grid>

          {/* Business Hours */}
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ p: 4, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
                Business Hours
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Saturday - Sunday:</strong> 10:00 AM - 4:00 PM
                  </Typography>
                </Grid>
              </Grid>
              <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                * Responses may take up to 24 hours on holidays
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </Stack>
  )
}
